module.exports = __webpack_public_path__ + "img/couples-026.51fcd453.jpg";